export default __webpack_public_path__ + "static/media/place-type-parking.65410649.svg";